/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Events_EmptyInputs */

const es_billing_events_empty = /** @type {(inputs: Billing_Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se registraron eventos de facturación en este período.`)
};

const en_billing_events_empty = /** @type {(inputs: Billing_Events_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No billing events were recorded for this period.`)
};

/**
* | output |
* | --- |
* | "No billing events were recorded for this period." |
*
* @param {Billing_Events_EmptyInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_events_empty = /** @type {((inputs?: Billing_Events_EmptyInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Events_EmptyInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_events_empty(inputs)
	return en_billing_events_empty(inputs)
});
export { billing_events_empty as "billing.events.empty" }